<script setup>
import { computed, ref } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';
import { appointmentMessage } from '../calendar/appointmentMessage';

const props = defineProps({
  event: { type: Object, required: true },
  conversation: { type: Object, required: true },
  contactId: { type: Number, required: true },
});
const expiredWindowLabel =
  'A janela de resposta encerrou. Envie um modelo aprovado pela conversa para retomar o contato.';
const store = useStore();
const inboxGetter = useMapGetter('inboxes/getInboxById');
const sending = ref(false);
const isWhatsapp = computed(() => {
  const inbox = inboxGetter.value(props.conversation.inbox_id) || {};
  return (
    inbox.channel_type === 'Channel::Whatsapp' ||
    (inbox.channel_type === 'Channel::TwilioSms' &&
      inbox.medium === 'whatsapp') ||
    (inbox.channel_type === 'Channel::Api' &&
      inbox.additional_attributes?.is_evolution_api_integration === true)
  );
});
const disabled = computed(
  () => sending.value || props.conversation.can_reply === false
);
const buttonLabel = computed(() =>
  sending.value ? 'Enviando…' : 'Enviar no WhatsApp'
);
const send = async () => {
  if (
    disabled.value ||
    !isWhatsapp.value ||
    props.conversation.meta?.sender?.id !== props.contactId
  )
    return;
  sending.value = true;
  try {
    await store.dispatch('createPendingMessageAndSend', {
      conversationId: props.conversation.id,
      message: appointmentMessage(props.event),
      private: false,
    });
    useAlert(
      'Agendamento encaminhado para envio. Acompanhe o status na conversa.'
    );
  } catch {
    useAlert(
      'Não foi possível enviar o agendamento. Confira o status da mensagem na conversa.'
    );
  } finally {
    sending.value = false;
  }
};
</script>

<template>
  <!-- eslint-disable vue/no-root-v-if -->
  <div v-if="isWhatsapp" class="mt-2">
    <Button
      sm
      ghost
      teal
      icon="i-simple-icons-whatsapp"
      :label="buttonLabel"
      :disabled="disabled"
      :is-loading="sending"
      @click="send"
    />
    <p
      v-if="conversation.can_reply === false"
      class="mb-0 mt-1 text-xs text-n-slate-11"
    >
      {{ expiredWindowLabel }}
    </p>
  </div>
</template>
